(function () {
  'use strict';

  var MOBILE_MAX = 749;

  function initCompare(section) {
    var sectionId = section.id.replace('js-pdp-compare-', '');
    var header    = document.getElementById('js-compare-header-' + sectionId);
    var footer    = document.getElementById('js-compare-footer-' + sectionId);
    var sticky    = document.getElementById('js-compare-sticky-' + sectionId);

    if (!header || !footer) return;

    /* ---- sticky banner (only when element is present) ---- */
    if (sticky) {
      var headerObs = null;
      var footerObs = null;

      function showSticky() {
        sticky.classList.add('is-visible');
        sticky.setAttribute('aria-hidden', 'false');
      }

      function hideSticky() {
        sticky.classList.remove('is-visible');
        sticky.setAttribute('aria-hidden', 'true');
      }

      function teardown() {
        if (headerObs) { headerObs.disconnect(); headerObs = null; }
        if (footerObs) { footerObs.disconnect(); footerObs = null; }
        hideSticky();
      }

      function setup() {
        if (window.innerWidth > MOBILE_MAX) {
          teardown();
          return;
        }

        var headerPassed = false;
        var footerPassed = false;

        function update() {
          if (headerPassed && !footerPassed) showSticky();
          else hideSticky();
        }

        headerObs = new IntersectionObserver(function (entries) {
          var e = entries[0];
          if (!e.isIntersecting && e.boundingClientRect.top < 0) headerPassed = true;
          else if (e.isIntersecting) headerPassed = false;
          update();
        }, { threshold: 0 });

        footerObs = new IntersectionObserver(function (entries) {
          var e = entries[0];
          footerPassed = !e.isIntersecting && e.boundingClientRect.top < 0;
          update();
        }, { threshold: 0 });

        headerObs.observe(header);
        footerObs.observe(footer);
      }

      setup();

      var resizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () { teardown(); setup(); }, 150);
      });
    }

    /* ---- ADD TO CART for current product (p1) ---- */
    initP1AddToCart(section);
  }

  function initP1AddToCart(sectionEl) {
    var addBtns = sectionEl.querySelectorAll('.js-compare-p1-add-btn');
    var oosBtns = sectionEl.querySelectorAll('.js-compare-p1-oos-btn');

    if (!addBtns.length) return;

    /* The main sticky ATC button already handles the correct variant ID,
       Mulberry, cart drawer, and all app integrations. Delegate to it. */
    var mainAddBtn = document.querySelector('button.btn-temp.product-form__submit');

    /* ---- Availability sync ---- */
    /* Mirror the main button's disabled state — toggleAddButton() is the
       single source of truth for availability across all product types. */
    function syncAvailability(available) {
      addBtns.forEach(function (btn) { btn.style.display = available ? '' : 'none'; });
      oosBtns.forEach(function (btn) { btn.style.display = available ? 'none' : ''; });
    }

    if (mainAddBtn) {
      new MutationObserver(function (mutations) {
        mutations.forEach(function (m) {
          if (m.attributeName === 'disabled') {
            syncAvailability(!mainAddBtn.hasAttribute('disabled'));
          }
        });
      }).observe(mainAddBtn, { attributes: true, attributeFilter: ['disabled'] });
    }

    /* ---- Delegate click to sticky ATC button ---- */
    sectionEl.querySelectorAll('.pdp-compare__add-form').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var addBtn = form.querySelector('.js-compare-p1-add-btn');
        if (!addBtn || !mainAddBtn) return;

        mainAddBtn.click();

        /* Brief visual feedback on our button while the main button works */
        var originalText = addBtn.textContent.trim();
        addBtn.disabled = true;
        addBtn.textContent = 'ADDING...';
        setTimeout(function () {
          addBtn.disabled = false;
          addBtn.textContent = originalText;
        }, 2000);
      });
    });
  }

  /* Boot every compare section on the page */
  document.querySelectorAll('[id^="js-pdp-compare-"]').forEach(initCompare);
})();
